module.exports = __webpack_public_path__ + "6d699ad2c6cfdc19dde8fd6603a0d478.jpg";